var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgVerificationIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 58,
  height: 58
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Verification Icon",
  transform: "translate(-4.726 -6)"
}, /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 2",
  cx: 29,
  cy: 29,
  r: 29,
  transform: "translate(4.726 6)",
  fill: "#f3f3f3"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Icon awesome-thumbs-up",
  d: "M25.956 33.364h-4.089a1.227 1.227 0 0 0-1.227 1.227v12.268a1.227 1.227 0 0 0 1.227 1.227h4.089a1.227 1.227 0 0 0 1.227-1.227V34.591a1.227 1.227 0 0 0-1.227-1.227Zm-2.044 12.677a1.227 1.227 0 1 1 1.228-1.227 1.227 1.227 0 0 1-1.228 1.227Zm16.357-19.963c0 2.168-1.328 3.384-1.7 4.833h5.2a3.054 3.054 0 0 1 3.044 2.97 3.7 3.7 0 0 1-.994 2.515l-.006.006a4.27 4.27 0 0 1-.476 4.062 4.042 4.042 0 0 1-.837 3.821 2.714 2.714 0 0 1-.314 2.281c-1.043 1.5-3.629 1.52-5.816 1.52h-.145a14.674 14.674 0 0 1-6.112-1.622 8.045 8.045 0 0 0-2.691-.827.614.614 0 0 1-.6-.613V34.097a.613.613 0 0 1 .182-.436c2.025-2 2.9-4.119 4.555-5.782a6.191 6.191 0 0 0 1.3-3.011c.227-.946.7-2.954 1.735-2.954 1.221 0 3.675.409 3.675 4.164Z",
  fill: "#4e4e4e"
}))));
export default SvgVerificationIcon;